import { singleton } from "logic/singleton";
const MAX_ENTRIES = 5e3;
const MAX_CANDIDATES = 5;
const MIN_PARTIAL_MATCH_LENGTH = 3;
const MIN_CONTAINED_RATIO = 0.5;
const WORD_CHARACTER = /[\p{L}\p{N}]/u;
const isWordCharacter = (character) => !!character && WORD_CHARACTER.test(character);
const containsWords = (text, part) => {
  let index = text.indexOf(part);
  while (index !== -1) {
    if (!isWordCharacter(text[index - 1]) && !isWordCharacter(text[index + part.length])) {
      return true;
    }
    index = text.indexOf(part, index + 1);
  }
  return false;
};
const isPartialMatch = (clicked, recorded) => {
  if (recorded.length < MIN_PARTIAL_MATCH_LENGTH || clicked.length < MIN_PARTIAL_MATCH_LENGTH) {
    return false;
  }
  if (recorded.length > clicked.length) {
    return clicked.length / recorded.length >= MIN_CONTAINED_RATIO && containsWords(recorded, clicked);
  }
  return containsWords(clicked, recorded);
};
const TAG = /<\/?[\w-]+\s*\/?>/g;
export const normalizeText = (text) => text.replace(TAG, "").replace(/\s+/g, " ").trim();
const textsToSources = singleton("i18n.renderedTranslations", () => /* @__PURE__ */ new Map());
const isSameSource = (a, b) => a.namespace === b.namespace && a.key === b.key;
export const recordTranslation = (text, source) => {
  var _a;
  if (typeof text !== "string") {
    return;
  }
  const normalized = normalizeText(text);
  if (!normalized) {
    return;
  }
  const existing = (_a = textsToSources.get(normalized)) != null ? _a : [];
  const sources = [...existing.filter((other) => !isSameSource(other, source)), source];
  textsToSources.delete(normalized);
  textsToSources.set(normalized, sources);
  if (textsToSources.size > MAX_ENTRIES) {
    textsToSources.delete(textsToSources.keys().next().value);
  }
};
export const findTranslations = (text) => {
  const normalized = normalizeText(text);
  if (!normalized) {
    return [];
  }
  const exact = textsToSources.get(normalized);
  if (exact) {
    return exact.map((source) => ({ ...source, text: normalized, exact: true }));
  }
  const partial = [];
  textsToSources.forEach((sources, recorded) => {
    if (isPartialMatch(normalized, recorded)) {
      sources.forEach(
        (source) => partial.push({
          ...source,
          text: recorded,
          exact: false,
          distance: Math.abs(recorded.length - normalized.length)
        })
      );
    }
  });
  return partial.sort((a, b) => a.distance - b.distance).filter((candidate, index, all) => all.findIndex((other) => isSameSource(other, candidate)) === index).slice(0, MAX_CANDIDATES).map(({ distance: _distance, ...candidate }) => candidate);
};
export const clearRenderedTranslations = () => textsToSources.clear();
